import {atom} from 'recoil';

import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

import {IPageableDto, IPageableTable} from '../../shared/types/pageable.types';
import {IDeviceModel} from '../../shared/types/deviceModels.types';
import {IDevice} from '../../shared/types/device.types';

export const deviceModelsState = atom<IPageableDto<IDeviceModel>>({
  key: 'deviceModelsState',
  default: getEmptyPage<IDeviceModel>(),
});

export const deviceModelsQueryTrigger = atom<number>({
  key: 'deviceModelsQueryTrigger',
  default: 0,
});

export const deviceModelsPageable = atom<IPageableTable>({
  key: 'deviceModelsPageable',
  default: {
    page: 0,
    size: localStorage.getItem('deviceModelsPerPage')
      ? parseInt(localStorage.getItem('deviceModelsPerPage') as string, 10)
      : 5,
  },
});

export const currentDeviceModelState = atom<IDeviceModel | null>({
  key: 'currentDeviceModelState',
  default: null,
});

export const deviceModelControlState = atom<boolean>({
  key: 'deviceModelControlState',
  default: false,
});

export const deviceModelControlModeState = atom<'ADD' | 'EDIT'>({
  key: 'deviceModelControlModeState',
  default: 'ADD',
});

export const devicesState = atom<IPageableDto<IDevice>>({
  key: 'devicesState',
  default: getEmptyPage<IDevice>(),
});

export const currentDeviceState = atom<IDevice | null>({
  key: 'currentDeviceState',
  default: null,
});

export const deviceControlModeState = atom<'ADD' | 'EDIT'>({
  key: 'deviceControlModeState',
  default: 'ADD',
});

export const deviceControlState = atom<boolean>({
  key: 'deviceControlState',
  default: false,
});

export const devicesQueryTrigger = atom<number>({
  key: 'devicesQueryTrigger',
  default: 0,
});

export const devicesPageable = atom<IPageableTable>({
  key: 'devicesPageable',
  default: {
    page: 0,
    size: localStorage.getItem('devicesPerPage') ? parseInt(localStorage.getItem('devicesPerPage') as string, 10) : 5,
  },
});
